import { render, staticRenderFns } from "./AddTenancyTenantTab.vue?vue&type=template&id=307b871f&scoped=true"
import script from "./AddTenancyTenantTab.vue?vue&type=script&lang=js"
export * from "./AddTenancyTenantTab.vue?vue&type=script&lang=js"
import style0 from "./AddTenancyTenantTab.vue?vue&type=style&index=0&id=307b871f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307b871f",
  null
  
)

export default component.exports